var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.mode)?_c('span',{staticClass:"text-color-secondary font-semi-bold"},[_vm._v("Ambiente "+_vm._s(_vm.getMode)+" ")]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }